import { useState, useEffect, useRef } from "react";
import { getCities, getJobTitles } from "../../../service/api";
import Typed from "typed.js";
import Select from "react-select";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Banner() {
  const typedEl = useRef(null);

  useEffect(() => {
    // Initialize Typed.js
    const typed = new Typed(typedEl.current, {
      strings: [
        // "Find the job that fits your life",
        // "Search thousands of opportunities",
        // "Build your career today",
        "India's most Trusted Hourly Job Portal",
        "Flexibility meets Opportunity",
      ],
      typeSpeed: 50,
      backSpeed: 30,
      loop: true,
    });

    // Load external scripts (particles + dots)
    const script = document.createElement("script");
    script.src = "/assets/js/particle-animation.js";
    script.async = true;
    document.body.appendChild(script);

    const script2 = document.createElement("script");
    script2.src = "/assets/js/dot-animation.js";
    script2.async = true;
    document.body.appendChild(script2);

    return () => {
      typed.destroy(); // cleanup Typed.js
      document.body.removeChild(script);
      document.body.removeChild(script2);
    };
  }, []);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [jobTitle, setJobTitle] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);
  const navigate = useNavigate();
  
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
  
    const loadSuggestions = async (text) => {
      if (!text) {
        setSuggestions([]);
        setShowSuggestions(false);
        return;
      }
  
      try {
        const res = await getJobTitles(text);
        if (res.status === 200 && res.data?.data) {
          setSuggestions(res.data.data);
          setShowSuggestions(true);
        }
      } catch (e) {
        console.error("Suggestion error:", e);
      }
    };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await getCities();
        if (res.status === 200 && res.data && res.data.data) {
          const formatted = res.data.data.map((city) => ({
            value: city,
            label: city,
          }));
          setOptions(formatted);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCities();
  }, []);

  const handleChange = (selectedOption) => {
    setSelectedCity(selectedOption.value);
    console.log("Selected city:", selectedOption.value); // <-- here you get the city
  };

  return (
    <section className="bannerSection wow animate__fadeIn">
      <div id="particles-js"></div>
      <div className="bannerImg">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/bg/banner-bgg.jpg`}
          alt="img"
        />
      </div>
      <div className="bannersearch">
        <div className="banenrTitle">
          <h3 className="wow animate__fadeInUp" data-wow-delay="0">
            <span ref={typedEl}
            style={{fontSize: "37px"}}/>
          </h3>
          <p className="wow animate__fadeInUp" data-wow-delay="0.2s">
            {/* Resume-Library is a true performance-based job board. Enjoy custom
            hiring products and access to up to 10,000 new resume registrations
            daily, with no subscriptions or user licences. */}
            Connecting employers and job seekers for hourly based work with flexibility, transperancy & security - making work & hiring faster, smarter and more convenient.
          </p>
        </div>
        <div className="searchBar wow animate__zoomIn">
          <form
            onSubmit={(e) => {
              e.preventDefault();

              // Build query string
              const params = new URLSearchParams();
              if (jobTitle) params.append("jobTitle", jobTitle);
              if (selectedCity) params.append("city", selectedCity);

              // Navigate to /job-list with query
              navigate(`/job-list?${params.toString()}`);
            }}
          >
            <div className="row-group-search">
              <div className="form-group form-group-1">
            <div style={{ position: "relative" }}>
              <i className="fa-solid fa-magnifying-glass"></i>
              <input
                type="text"
                className="input-filter-search"
                placeholder="Job title, key words..."
                value={jobTitle}
                onChange={(e) => {
                  setJobTitle(e.target.value);
                  loadSuggestions(e.target.value);
                }}
              />

              {showSuggestions && suggestions.length > 0 && (
                <div
                  className="suggestion-box"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "#fff",
                    border: "1px solid #ddd",
                    zIndex: 1000,
                    borderRadius: "6px",
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {suggestions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "8px 10px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setJobTitle(item);
                        setShowSuggestions(false);
                      }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              )}
            </div>
                {/* <input
                  className="input-filter-search"
                  placeholder="Job title, key words or company"
                  type="text"
                  name="jobTitle"
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                /> */}
              </div>

              <div className="form-group form-group-2">
                <i className="fa-solid fa-location-crosshairs"></i>
                <Select
                  id="select-location"
                  name="city"
                  className="select-location"
                  options={options}
                  isLoading={loading}
                  isSearchable
                  placeholder="Search Location..."
                  onChange={(opt) => setSelectedCity(opt ? opt.value : null)}
                  value={
                    options.find((opt) => opt.value === selectedCity) || null
                  }
                />
              </div>

              <div className="form-group-4">
                <button type="submit" className="searchbtn">
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Banner;
